// Mount order, stylesheet order and the mocks-before-React rule all live in
// @dedupr/app-kit's bootstrap, so they are stated once for every app rather
// than restated per entry point (TODO B-58).
import { bootstrap, setApiTokenProvider } from '@dedupr/app-kit';
import { App } from './App.js';
import { accessToken } from './auth.js';
import { captureInstallPrompt, registerServiceWorker } from './pwa.js';
import { warmMatchEngine } from './local/useLocalMatch.js';

/* ⚠️ **Before `bootstrap`, because the first render issues the first request.** The API client
   defaulted to sending no token at all — a stale "auth is not built yet" default that survived
   ADR-069 building it. Live, `/v1/` answered 401 and the shell rendered "something went wrong on
   our side": the API was right, the client was silent, and the screen blamed the server.
   `accessToken()` refreshes a token that is about to expire, so this hands over a usable one rather
   than whatever was last minted. */
setApiTokenProvider(accessToken);

bootstrap(App);

/**
 * Install the offline shell — `my.dedupr.cloud` is the PWA, so this is what makes it installable and
 * usable with no network.
 *
 * ⚠️ **Deliberately after `bootstrap`, and refused in mock mode**, for a specific reason:
 * `bootstrap` starts MSW, which registers **its own** service worker at the same scope. Two workers
 * cannot both control one scope — the later registration wins — so registering ours in mock mode
 * would silently disable request interception and the app would start calling a backend that does
 * not exist. That presents as a broken app rather than as a conflict, which is the worst kind of
 * failure to debug.
 */
void registerServiceWorker();

/* Captured before React mounts. `beforeinstallprompt` fires early in page load, and a listener added
   after mount misses it — the prompt is then unavailable for the rest of the session with no way to
   get it back. */
captureInstallPrompt();

/* Pull the match engine's Worker chunk into the cache while there is still a network.
   ⚠️ Without this the app installs, goes offline, and then finds duplicates in nothing: the engine is
   a separate on-demand chunk, so it was the one file NOT cached — and the run failed silently rather
   than reporting anything. */
warmMatchEngine();
